"use strict";
/**
  * Get the frame of an IRI that we expect to be in the SHACL namespace
  */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShaclName = void 0;
// eslint-disable-next-line import/prefer-default-export
function getShaclName(term) {
    if (term.termType !== 'NamedNode' || !term.value.startsWith("http://www.w3.org/ns/shacl#" /* sh._ */)) {
        throw new Error(`Term ${term.value} is not part of the SHACL namespace`);
    }
    return term.value.slice(27);
}
exports.getShaclName = getShaclName;
